import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface BackLinkProps {
  /** Omit for an icon-only affordance (e.g. a chat header next to an avatar) — still gets an aria-label. */
  label?: string;
  onClick: () => void;
  className?: string;
}

/**
 * In-page "back to X" link — rendered above a page's content (offering detail,
 * inquiry composer, wizard exit, etc.), as opposed to GoBackButton's top-nav
 * history pill. One canonical look so student/teacher pages stop each
 * rendering their own ArrowLeft/ChevronLeft + text markup.
 */
export function BackLink({ label, onClick, className }: BackLinkProps) {
  return (
    <button
      onClick={onClick}
      aria-label={label ?? "Back"}
      className={cn(
        "inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-800 transition-colors cursor-pointer",
        className,
      )}
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </button>
  );
}
